import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { Input } from "antd";
import { useContext, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { ProjectService } from "../../../../../services";
import { useMemo } from "react";
import { isEmptyOrSpaces } from "../../../../../helpers/StringHelper";
import { Style } from './style';
import { Item } from './item';
import { EmptyState } from "./emptyState";
import { useTranslation } from "react-i18next";
import { ProjectSourcesContext } from "../../../../../context/ProjectSources";
import { checkPermission } from "../../../../../permissions/usePermissions";

export default function ProjectSources({ user, conf = {} }) {
  const { t } = useTranslation();
  const { data = {}, form = {}, group } = conf;
  const [search, setSearch] = useState('');
  const { info, setInfo } = useContext(ProjectSourcesContext);
  const items = useMemo(() => group === 'informationSources' ? (data.sources || []) : (data.clients || []), [data, group]);
  const isEmpty = (items || []).length === 0;
  const canEdit = checkPermission({ permission: 'projects.canEdit', permissions: user?.role?.permissions });

  const getData = async () => {
    try {
      const _data = [];
      const _filteredItems = items.filter((i) => !info.find((item) => item.id === i.authorId));

      if (_filteredItems.length) {
        for (let i = 0; i < _filteredItems.length; i++) {
          const item = items[i];
          const res = await ProjectService.getLinking(item.authorId, data.id, item.role);
          if (res.data) {
            _data.push(res.data.data);
          }
        }
      }

      setInfo([...info, ..._data]);
    } catch (err) {
      console.log(err);
    }
  }

  const mappedItems = useMemo(() => {
    const _items = items.map((item) => {
      const fromInfo = info.find((i) => i.id === item.authorId);
      const isOwnData = user.company.id === item.authorId;
      return { ...item, data: fromInfo, isOwnData }
    });
    const _ownData = _items.find((it) => it.isOwnData);
    return _ownData ?
      [_ownData, ..._items.filter((it) => !it.isOwnData)]
      : _items;
  }, [user, info, items]);

  const filteredItems = useMemo(() => {
    if (isEmptyOrSpaces(search)) {
      return mappedItems;
    }

    return mappedItems.filter((item) => {
      const name = item.sourceName || '';

      const condition = name.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1
        || (item.data?.name || '').toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1
        || (item.data?.email || '').toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1
        || (item.data?.datastakeId || '').toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;

      if (item.isOwnData) {
        return condition || t('Own Data').toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
      }

      return condition;
    });
  }, [mappedItems, search, t]);

  const sorted = useMemo(() => {
    if (Array.isArray(filteredItems)) {
      return filteredItems.sort((a, b) => {
        const valA = a.status === 'approved' ? 3 : a.status === 'pending' ? 2 : 1;
        const valB = b.status === 'approved' ? 3 : b.status === 'pending' ? 2 : 1;
        return valB - valA;
      });
    }
    return [];
  }, [filteredItems]);

  useEffect(() => {
    setSearch('');
    getData();
  }, [group]);

  return (
    <Style
      className={formatClassname([
        'content',
        'project-sources-layout',
        'p-0'
      ])}
      style={{}}
    >
      <div className="main-cont">
        <div className="project-header">
          <h1>{form.label || ''}</h1>
          {(!isEmpty || true) && (
            <Input
              prefix={<SearchOutlined />}
              value={search}
              placeholder={t('Search')}
              size="large"
              onChange={(e) => setSearch(e.target.value)} />
          )}
        </div>
        <div className={formatClassname(["subject-body", isEmpty && 'no-data'])}>
          {canEdit && <EmptyState t={t} conf={conf} />}
          {(sorted || []).map((item) => (
            <Item item={item} key={`items-${item.authorId}`} />
          ))}
        </div>
      </div>
    </Style>
  );
}
